export default {"src":"/_next/static/media/12-300x49.f692d962.svg","height":17,"width":102,"blurWidth":0,"blurHeight":0};